var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('div',{staticClass:"headerBox"},[_c('HeaDers')],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }